// Fechas que manda el backend: hora Venezuela sin zona ("2026-10-16T07:51:02").

export const aFecha = (iso) => (iso ? new Date(iso) : null);

export const hora = (iso) => {
    const d = aFecha(iso);
    return d ? d.toLocaleTimeString('es-VE', { hour: 'numeric', minute: '2-digit' }) : '';
};

export const horaConSegundos = (iso) => {
    const d = aFecha(iso);
    return d ? d.toLocaleTimeString('es-VE', { hour: 'numeric', minute: '2-digit', second: '2-digit' }) : '';
};

export const fechaCorta = (iso) => {
    const d = aFecha(iso);
    return d ? d.toLocaleDateString('es-VE', { day: 'numeric', month: 'short' }) : '';
};

export const hace = (iso, ahora = new Date()) => {
    const d = aFecha(iso);
    if (!d) return '';
    const seg = Math.max(0, Math.round((ahora - d) / 1000));
    if (seg < 60) return 'hace un momento';
    const min = Math.round(seg / 60);
    if (min < 60) return `hace ${min} min`;
    const h = Math.round(min / 60);
    if (h < 24) return `hace ${h} h`;
    const dias = Math.round(h / 24);
    return dias === 1 ? 'ayer' : `hace ${dias} días`;
};

export const esHoy = (iso) => {
    const d = aFecha(iso);
    if (!d) return false;
    const hoy = new Date();
    return d.toDateString() === hoy.toDateString();
};

export const hoyISO = () => {
    const d = new Date();
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// '17:04' -> '5:04 p. m.' (nunca hora militar en pantalla)
export const horaAmPm = (hhmm) => {
    if (!hhmm) return '';
    const [h, m] = hhmm.split(':').map(Number);
    return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'a. m.' : 'p. m.'}`;
};

const DIAS_CORTOS = ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'];

// Resume una jornada de 7 días: "lun a jue: 8:00 a. m. a 5:00 p. m.; vie: 8:00 a. m. a 4:30 p. m."
export const resumenJornada = (jornada) => {
    const grupos = [];
    (jornada || []).forEach((t, i) => {
        const clave = t ? `${t.entrada}-${t.salida}` : null;
        const ultimo = grupos[grupos.length - 1];
        if (clave && ultimo && ultimo.clave === clave && ultimo.hasta === i - 1) ultimo.hasta = i;
        else if (clave) grupos.push({ clave, desde: i, hasta: i, t });
    });
    return grupos.map((g) => {
        const dias = g.desde === g.hasta ? DIAS_CORTOS[g.desde] : `${DIAS_CORTOS[g.desde]} a ${DIAS_CORTOS[g.hasta]}`;
        return `${dias}: ${horaAmPm(g.t.entrada)} a ${horaAmPm(g.t.salida)}`;
    }).join('; ');
};
